import React, { useEffect, useState } from 'react';
import { Link, NavLink, useLocation } from 'react-router-dom';
import { AnimatePresence, motion } from 'framer-motion';
import { MenuIcon, XIcon } from 'lucide-react';
import { ButtonLink } from './ButtonLink';
import { LinkedInIcon } from './LinkedInIcon';
import { contactDetails, navItems } from '../data/content';
export function Header() {
  const [open, setOpen] = useState(false);
  const {
    pathname
  } = useLocation();
  useEffect(() => setOpen(false), [pathname]);
  return <header className="sticky top-0 z-50 border-b border-hairline bg-white/95 backdrop-blur" data-id="element-86" data-mp="2wkgtg8cq1iyt">
      <div className="mx-auto flex h-20 max-w-7xl items-center justify-between px-6 lg:px-8" data-id="element-87" data-mp="31bfe1k4qt37v">
        <Link to="/" className="group flex flex-col leading-none" aria-label="Dr. Tom Vecchione — Home" data-id="element-88" data-mp="36bl4wy36ulow">
          <span className="font-serif text-xl font-semibold text-navy" data-id="element-89" data-mp="3baxtbn9pk0tl">Dr. Tom Vecchione</span>
          <span className="mt-1.5 text-[10.5px] font-medium uppercase tracking-[0.2em] text-steel" data-id="element-90" data-mp="3fb86pkztxtih">
            Ph.D. · CPRW · CIC · CDCS
          </span>
        </Link>

        <nav className="hidden items-center gap-9 lg:flex" aria-label="Primary" data-id="element-91" data-mp="2wii064m54mnf">
          {navItems.map(item => <NavLink key={item.to} to={item.to} end={item.to === '/'} className={({
          isActive
        }) => `relative py-2 text-sm font-medium transition-colors duration-150 ${isActive ? 'text-navy' : 'text-steel hover:text-navy'} after:absolute after:inset-x-0 after:-bottom-0.5 after:h-px after:bg-gold after:transition-transform after:duration-200 after:ease-crisp ${isActive ? 'after:scale-x-100' : 'after:scale-x-0'}`} data-id="element-92" data-mp="2mm54j171byq1">
              {item.label}
            </NavLink>)}
        </nav>

        <div className="hidden items-center gap-4 lg:flex" data-id="element-93" data-mp="1yisk8sl20jh">
          <a href={contactDetails.linkedin} target="_blank" rel="noreferrer" aria-label="LinkedIn profile" className="flex h-11 w-11 items-center justify-center border border-hairline text-[#0A66C2] transition-colors duration-150 hover:border-[#0A66C2]" data-id="element-94" data-mp="3ta2945badybs">
            <LinkedInIcon className="h-5 w-5" data-id="element-95" data-mp="1hni0zp65apnz" />
          </a>
          <ButtonLink to="/contact" className="h-11 px-5" data-id="element-96" data-mp="1mm301l9nv3au">
            Schedule Strategy Session
          </ButtonLink>
        </div>

        <button type="button" onClick={() => setOpen(v => !v)} className="inline-flex h-10 w-10 items-center justify-center rounded-sm text-navy lg:hidden" aria-expanded={open} aria-controls="mobile-menu" aria-label={open ? 'Close menu' : 'Open menu'} data-id="element-97" data-mp="18ls8eg0j1kom">
          {open ? <XIcon className="h-6 w-6" data-id="element-98" data-mp="2t2x6jhcf6pup" /> : <MenuIcon className="h-6 w-6" data-id="element-99" data-mp="2t2ngjtrdkip0" />}
        </button>
      </div>

      <AnimatePresence data-id="element-100" data-mp="2y204khtzfvt6">
        {open && <motion.nav id="mobile-menu" initial={{
        opacity: 0,
        y: -8
      }} animate={{
        opacity: 1,
        y: 0
      }} exit={{
        opacity: 0,
        y: -8
      }} transition={{
        duration: 0.2,
        ease: [0.23, 1, 0.32, 1]
      }} className="border-t border-hairline bg-white px-6 pb-6 pt-2 lg:hidden" aria-label="Mobile" data-id="element-101" data-mp="2y0p0si0jeo22">
            {navItems.map(item => <NavLink key={item.to} to={item.to} end={item.to === '/'} className={({
          isActive
        }) => `block border-b border-hairline py-4 font-serif text-lg ${isActive ? 'text-navy' : 'text-steel'}`} data-id="element-102" data-mp="rcg7kr0jsg3c">
                {item.label}
              </NavLink>)}
            <ButtonLink to="/contact" className="mt-6 w-full" data-id="element-103" data-mp="1a5k4qmcz5b2p">
              Schedule Strategy Session
            </ButtonLink>
          </motion.nav>}
      </AnimatePresence>
    </header>;
}